document.querySelectorAll('.media-text-dynamic').forEach( node => {
	const image  = node.querySelector( '.media-text-dynamic__media' );
	const types  = node.querySelector( '.media-text-dynamic__type' );
	const title  = node.querySelector( '.media-text-dynamic__title' );
	const footer = node.querySelector( '.media-text-dynamic__meta' );

	if ( image ) {
		image.dataset.animation = 'image';
		image.dataset.animationDelay = '200';
	}

	if ( types ) {
		types.dataset.animation = 'block';
		types.dataset.animationDelay = '500';
	}

	if ( title ) {
		title.dataset.animation = 'lines';
		title.dataset.animationDelay = '800';
	}

	if ( footer ) {
		footer.dataset.animation = 'block';
		footer.dataset.animationDelay = '1100';
	}
} );
